'use client';

import React from 'react';
import { Heading, LogoRotator } from '@ui';
import { Section, Container } from '@layout';
import MarkupSnippet, { markupCopyLabels } from '../markup-snippet/MarkupSnippet';

interface LogoRotatorDemoProps {
  sectionID?: string;
  classes?: string;
  isSpanish?: boolean;
}

const LogoRotatorDemo: React.FC<LogoRotatorDemoProps> = ({
  isSpanish = false,
  sectionID = 'logo-rotator-demo',
  classes = '',
}) => (
  <LogoRotatorDemoInner sectionID={sectionID} className={classes} isSpanish={isSpanish} />
);

export default LogoRotatorDemo;

const LogoRotatorDemoInner: React.FC<{
  sectionID: string;
  className?: string;
  isSpanish?: boolean;
}> = ({
  isSpanish = false,
  sectionID,
  className,
}) => {
  const t = (en: string, es: string) => (isSpanish ? es : en);

  return (
    <Section sectionID={sectionID} className={className}>
      <Container>
        <Heading as='h3'>{t('Logo Rotator Demo', 'Demo del Rotador de Logos')}</Heading>
        <p className='sub full'>
          {t(
            'A demo of the LogoRotator component, rotating through 20 Cards with icons.',
            'Demo del componente LogoRotator, rotando 20 tarjetas con iconos.'
          )}
        </p>
        <LogoRotator surface='sf-3' locale={isSpanish ? 'es' : 'en'} />
      <MarkupSnippet
          {...markupCopyLabels(isSpanish)}
          code={`<div class="rotator-container">
  <div class="rotator-track">
    <div class="card logo-rotator-card"><svg class="icon" aria-hidden="true"></svg></div>
  </div>
</div>`}
        />
      </Container>
    </Section>
  );
};
